import axios from 'axios'
import config from '../config/dev.json'
import production from '../config/production.json'

const path = '/api/contact'
let url

if (process.env.NODE_ENV === 'production') url = production.host + path
else url = config.host + path

url = 'http://102.219.178.151/backend/api/categories/sub-categories'

export function GetAllCategories() {
  return new Promise((resolve, reject) => {
    axios.get(url).then(response => {
      resolve(response.data)
    }).catch(err => resolve("echeck"))
  })
}

export function AddTagsService(tags) {
    return new Promise((resolve, reject) => {
        axios.post(url + '/' + tags.categories[0] + '/tags', tags).then(response => {
            resolve(response)
        }).catch(err => resolve("echeck"))
    }) 
}

export function UpdateTagsService(tags) {
    console.log("tagsaaa",tags);
    return new Promise((resolve, reject) => {
        axios.put(url + '/' + tags.categories[0] + '/tags/' + tags._id, tags).then(response => {
            resolve(response.data)
        }).catch(err => reject(err))
    }) 
}

export function DeleteTagsService(tags) {
    return new Promise((resolve, reject) => {
        axios.delete(url + '/' + tags.categories[0] + '/tags/' + tags._id).then(response => {
            resolve(response)
        }).catch(err => reject(err))
    }) 
}


